<script>
  import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'
  import { Input, Button, Select } from 'ant-design-vue'

  Vue.use(Input)
  Vue.use(Button)
  Vue.use(Select)

  export default {
    name: 'NewTicket',
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      ...mapState('newTicket', ['metadata']),
      issue: {
        get() {
          return this.$store.state.issue
        },
        set(issue) {
          this.$store.commit('issue', issue)
        }
      },
      types() {
        const project = this.metadata.find(p => p.id === this.issue.project)
        return project ? project.issuetypes.filter(e => !e.subtask) : []
      }
    },
    methods: {
      ...mapActions('newTicket', ['createTicket', 'ticketMetadata']),
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      },
      create() {
        this.createTicket()
          .then((issue) => this.$emit('created', issue))
      }
    },
    created() {
      this.ticketMetadata()
    }
  }
</script>

<template>
  <div>
    <a-select v-model="issue.project" show-search>
      <a-select-option
        v-for="project of metadata"
        :key="project.id"
        :value="project.id"
        :filter-option="filterOption"
      >
        {{ project.name }}
      </a-select-option>
    </a-select>

    <a-select v-model="issue.type">
      <a-select-option
        v-for="type of types"
        :key="type.id"
        :value="type.id"
      >
        {{ type.name }}
      </a-select-option>
    </a-select>

    <a-input v-model="issue.title" />

    <a-button-group>
      <a-button type="primary" @click="create">Create</a-button>
      <a-button @click="$emit('cancel')">Cancel</a-button>
    </a-button-group>
  </div>
</template>

<style scoped>
  .ant-select {
    min-width: 250px;
  }
</style>
